export default "__VITE_ASSET__D1FVUoFK__"